export const plans = {
  0: 'Teste',
  1: 'B',
  2: 'Taesa',
  3: 'A',
};

export const PLANO_B = '1';
export const PLANO_TAESA = '2';
